export enum StateMovementInsuranceEnum {
  SOSPESA = 'SOSPESA',
  ANNULLATA = 'ANNULLATA',
  ATTIVA = 'ATTIVA',
}
